import { render } from "./EditColis.vue?vue&type=template&id=3d221f52&ts=true"
import script from "./EditColis.vue?vue&type=script&lang=ts"
export * from "./EditColis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__